import _ from 'underscore';
import videojs from 'video.js';

const MenuButton = videojs.getComponent('MenuButton');
const MenuItem = videojs.getComponent('MenuItem');

// @ts-ignore
const PrivacyEntry = videojs.extend(MenuItem, {
  constructor(player: any, options: any) {
    MenuItem.call(this, player, options);
    this.link = options.link;
  },

  handleClick(event: any) {
    MenuItem.prototype.handleClick.call(this, event);
    window.open(this.link);
  },
});

const registerPrivacyIcon = ({ accountConfig, defaultConfig }: any) => {
  try {
    if (accountConfig.enable === false) { return; }
    if (accountConfig.enable !== true && defaultConfig.enable === false) { return; }

    const items: any = accountConfig.enable === true ? accountConfig.entries : defaultConfig.enable ? defaultConfig.entries : [];

    // @ts-ignore
    const PrivacyIcon = videojs.extend(MenuButton, {
      constructor(player: any, options: any) {
        MenuButton.call(this, player, options);

        player.one('ready', (() => null).bind(this));

        this.controlText('Open privacy info menu');
      },

      buildWrapperCSSClass() {
        return 'vjs-privacy-info-selector ' + MenuButton.prototype.buildWrapperCSSClass.call(this);
      },

      createItems() {
        const player = this.player();

        return _.map(
          items,
          ((item: any) => {
            return new PrivacyEntry(player, item);
          }).bind(this)
        );
      },
    });

    videojs.registerComponent('PrivacyIcon', PrivacyIcon);
  } catch ({ message }) {
    console.error(message);
  }
};

export default registerPrivacyIcon;
